<template>
  <div>
    <ul class="nav nav-tabs flex-row my-3 my-md-5" role="tablist">
      <li class="nav-item col auto col-md-auto p-0">
        <a :class="{ active: activeTab == 'artworks' }" @click="changeTab('artworks')">
          {{ I18n.t("search_page.tabs.artworks") }}
          <sup class="m-0" v-if="activeTab == 'artworks'">{{ totalArtworksCount }}</sup>
        </a>
      </li>
      <li class="nav-item col auto col-md-auto p-0">
        <a :class="{ active: activeTab == 'incomingArtworks' }" @click="changeTab('incomingArtworks')">
          {{ I18n.t("search_page.tabs.incoming_auctions") }}
          <sup class="m-0" v-if="activeTab == 'incomingArtworks'">{{ totalArtworksCount }}</sup>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';
  import { UPDATE_ACTIVE_TAB, CLEAR_ARTWORKS_STATE_FILTERS } from '../store/mutation-types';

  export default {
    name: 'SearchTabs',
    computed: {
      ...mapGetters(['activeTab', 'totalArtworksCount']),
      ...mapState(['mainQuery']),
    },
    created() {
      this.setTab();
    },
    methods: {
      changeTab(tabName) {
        this.$store.commit(UPDATE_ACTIVE_TAB, { activeTab: tabName });
        this.$store.commit(CLEAR_ARTWORKS_STATE_FILTERS);
      },
      setTab() {
        if (Object.prototype.hasOwnProperty.call(this.$route.query, 'scope') && this.$route.query.scope.includes('incomingArtworks')) {
          this.changeTab('incomingArtworks');
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/tabs.vue?08ddefc1